import React, { useEffect, useRef } from 'react';
import './Sigiriya.css';
import negombo1 from '../../img/webp/negombo1.webp';
import negombo2 from '../../img/webp/negombo2.webp';
import negombo3 from '../../img/webp/negombo3.webp';
import negombo4 from '../../img/webp/negombo4.webp';
import DestinationSuggestions from '../../components/DestinationSuggestions';
import { getRandomSuggestions } from '../../data/destinationsData';
import SearchBar from '../../components/SearchBar';
const Negombo: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="destination-page">
      <SearchBar contentRef={contentRef} placeholder="Search Negombo information..." />
      
      <div ref={contentRef}>
      <section className="dest-hero">
        <img src={negombo1} alt="Negombo" />
        <div className="dest-badge">Negombo</div>
      </section>

      <section className="dest-content">
        <div className="dest-container">
          <div className="dest-main-section">
            <div className="dest-left">
              <img
                src={negombo2}
                alt="Negombo Beach"
              />
            </div>
            <div className="dest-right">
              <h1 className="dest-title">Why Visit Negombo?</h1>
              <p className="dest-description">
                Negombo is a popular entry and exit point for travelers due to its proximity to Bandaranaike International Airport. The town is known for its fishing industry and sandy beaches.
              </p>
              <ul className="dest-features">
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Convenient travel arrangements
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Flexible short-stay plans
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Comfortable coastal experience
                </li>
              </ul>
              <div className="dest-meta">
                <span>🚗 Land Trip</span>
                <span>📅 1 Day</span>
                <span>🎯 Sightseeing</span>
              </div>
            </div>
          </div>

          <div className="dest-bottom-section">
            <div className="dest-bottom-left">
              <p className="dest-bottom-text">
                Negombo is a lively coastal town located just 10 kilometers from Bandaranaike International Airport, making it a popular first or last stop for travelers. The town is famous for its rich fishing heritage, bustling fish markets, sandy beaches, and Dutch colonial architecture including old churches and canals.
              </p>
              <p className="dest-bottom-text">
                Visitors can explore the Negombo Lagoon, enjoy fresh seafood at beachside restaurants, visit St. Mary's Church, and relax on the beach. Its convenient location and coastal charm make Negombo an ideal destination for short stays and easy relaxation.
              </p>
            </div>
            <div className="dest-bottom-right">
              <img
                src={negombo3}
                alt="Negombo Market"
              />
            </div>
          </div>

          {/* Ceylon D Tour Section */}
          <div className="dest-main-section" style={{ marginTop: '4rem' }}>
            <div className="dest-left">
              <img
                src={negombo4}
                alt="Ceylon D Tour Negombo experience"
              />
            </div>
            <div className="dest-right">
              <p className="dest-description">
                Ceylon D Tour provides convenient Negombo travel services including airport transfers, city tours, and accommodation arrangements. Our packages cover visits to the fish market, lagoon boat rides, Dutch Fort, and beach relaxation spots. With flexible scheduling and reliable transportation, Ceylon D Tour ensures a smooth and enjoyable Negombo experience, perfect for starting or ending your Sri Lankan adventure comfortably.
              </p>
            </div>
          </div>

          {/* Destination Suggestions */}
          <DestinationSuggestions 
            currentDestination="Negombo"
            suggestions={getRandomSuggestions('/places/negombo', 4)}
          />
        </div> {/* End of dest-container */}
      </section>
      </div>
    </div>
  );
};

export default Negombo;

